import { Injectable } from '@angular/core';

import { BasicWeave } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class BasicWeaveService extends TmsWebBaseEditService<BasicWeave, BasicWeave> {
  constructor() {
    super('BasicWeave', $localize`Basic Weave`);
  }
}
